export default "/images/vendor/flag-icon-css/flags/1x1/iq.svg?e549011efede8b5ba38b8b2af9915c2e";